/**
 * Shared helpers for applying Knockout bindings without double-binding errors.
 * Requires knockout to be loaded first.
 */
(function (global) {
    'use strict';

    function resolveElement(elementOrId) {
        if (!elementOrId) {
            return null;
        }

        if (typeof elementOrId === 'string') {
            return document.getElementById(elementOrId);
        }

        return elementOrId;
    }

    function hasBindingContext(node) {
        return node && (node.nodeType === 1 || node.nodeType === 8) && !!global.ko.contextFor(node);
    }

    function isWithinBoundSubtree(element) {
        var node = element;

        while (node) {
            if (hasBindingContext(node)) {
                return true;
            }

            node = node.parentElement;
        }

        return false;
    }

    /**
     * Applies bindings to an element only when it is not already within a bound subtree.
     * @returns {boolean} true when bindings were applied
     */
    global.applyBindingsSafely = function (viewModel, elementOrId) {
        var element = resolveElement(elementOrId);

        if (!element || isWithinBoundSubtree(element)) {
            return false;
        }

        global.ko.applyBindings(viewModel, element);
        return true;
    };

    /**
     * Applies bindings to an element as its own independent binding root, even when the
     * element sits inside an already-bound subtree (e.g. lazy-loaded member-detail panes
     * injected into the admin-listing-bound `.body-content`). The element is cleaned first
     * so ko.applyBindings will not throw "cannot apply bindings multiple times" on it.
     *
     * Use this instead of applyBindingsSafely when a nested root is intended and the
     * ancestor bound-subtree check would otherwise skip the binding.
     * @returns {boolean} true when bindings were applied
     */
    global.applyBindingsAsRoot = function (viewModel, elementOrId) {
        var element = resolveElement(elementOrId);

        if (!element) {
            return false;
        }

        global.ko.cleanNode(element);
        global.ko.applyBindings(viewModel, element);
        return true;
    };

    /**
     * Applies bindings to the main admin page content region.
     * @returns {boolean} true when bindings were applied
     */
    global.applyBindingsToPageContent = function (viewModel) {
        var pageContentRoot = document.querySelector('.body-content');

        if (!pageContentRoot) {
            return false;
        }

        return global.applyBindingsSafely(viewModel, pageContentRoot);
    };

    /**
     * Applies bindings to the admin body container (includes content appended alongside .body-content).
     * @returns {boolean} true when bindings were applied
     */
    global.applyBindingsToBodyContainer = function (viewModel) {
        var bodyContainer = document.querySelector('.body-container');

        if (!bodyContainer) {
            return false;
        }

        return global.applyBindingsSafely(viewModel, bodyContainer);
    };
})(window);
